import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconBell, IconPlay, IconHome, IconCompass, IconPlus, IconUser } from './Icons';
import { useAuth } from '../core/firebase/useAuth';
import { useAuthModal } from '../core/AuthModalContext';

const tabs = [
  { path: '/notifications', Icon: IconBell,    label: 'Notifications', protected: true  },
  { path: '/videos',        Icon: IconPlay,    label: 'Videos',        protected: false },
  { path: '/',              Icon: IconHome,    label: 'Home',          protected: false },
  { path: '/explore',       Icon: IconCompass, label: 'Explore',       protected: false },
  { path: '/creer',         Icon: IconPlus,    label: 'Créer',         protected: true  },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { showAuthModal } = useAuthModal();

  const handleNav = (tab) => {
    if (tab.protected && !user) showAuthModal();
    else navigate(tab.path);
  };

  return (
    <aside className="app-sidebar">
      <div style={styles.logoRow} onClick={() => navigate('/')}>
        <div style={styles.logoMark}>
          <img src="/og-image.png" alt="Nexsap" style={styles.logoImg} />
        </div>
        <span style={styles.logoText} className="sidebar-label">Nexsap</span>
      </div>

      <div style={styles.divider} />

      {tabs.map((tab) => {
        const active = pathname === tab.path;
        return (
          <button
            key={tab.path}
            className={`sidebar-btn${active ? ' sidebar-btn-active' : ''}`}
            style={{
              ...styles.navItem,
              background: active ? '#E7F0FD' : 'transparent',
              borderLeft: active ? '3px solid #1877F2' : '3px solid transparent',
            }}
            onClick={() => handleNav(tab)}
          >
            <tab.Icon size={21} color={active ? '#1877F2' : '#65676B'} />
            <span
              className="sidebar-label"
              style={{
                ...styles.navLabel,
                color: active ? '#1877F2' : '#1C1E21',
                fontWeight: active ? 700 : 500,
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}

      <div style={{ flex: 1 }} />

      <div style={styles.divider} />

      <button
        className={`sidebar-btn${pathname === '/profile' ? ' sidebar-btn-active' : ''}`}
        style={{
          ...styles.navItem,
          background: pathname === '/profile' ? '#E7F0FD' : 'transparent',
          borderLeft: pathname === '/profile' ? '3px solid #1877F2' : '3px solid transparent',
        }}
        onClick={() => { if (!user) showAuthModal(); else navigate('/profile'); }}
      >
        <IconUser size={21} color={pathname === '/profile' ? '#1877F2' : '#65676B'} />
        <span
          className="sidebar-label"
          style={{
            ...styles.navLabel,
            color: pathname === '/profile' ? '#1877F2' : '#1C1E21',
            fontWeight: pathname === '/profile' ? 700 : 500,
          }}
        >
          Profile
        </span>
      </button>
    </aside>
  );
}

const styles = {
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    cursor: 'pointer',
    padding: '8px 16px',
    marginBottom: 8,
    width: '100%',
  },
  logoMark: {
    width: 34,
    height: 34,
    borderRadius: 10,
    background: 'linear-gradient(135deg, #1877F2, #0a5fd1)',
    padding: 2,
    flexShrink: 0,
    overflow: 'hidden',
  },
  logoImg: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
    objectFit: 'cover',
  },
  logoText: {
    color: '#1877F2',
    fontWeight: 800,
    fontSize: 17,
    whiteSpace: 'nowrap',
    letterSpacing: '-0.2px',
  },
  divider: {
    width: '80%',
    height: 1,
    background: '#E4E6EA',
    margin: '8px auto 12px',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    border: 'none',
    cursor: 'pointer',
    borderRadius: '0 10px 10px 0',
    padding: '11px 16px',
    width: '100%',
    textAlign: 'left',
  },
  navLabel: {
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
};
